import React, { useState, useEffect } from 'react'
import ReactPlayer from 'react-player'
import { convertVideoResolution, getCurrentLanguage, getPosterframe } from '../../assets/js/functions';
import { domain } from "../../assets/js/api";

export default function ViewVideo({ fragment, pauseGlobal, mute, index, current, mobileHidden }) {

    const [pause, setPause] = useState(true);
    const [hidden, setHidden] = useState(true);

    useEffect(() => {
        const hidden = index !== current;
        setHidden(hidden);
        if (hidden) {
            setPause(true);
        } else {
            setPause(pauseGlobal);
        }
    }, [pauseGlobal, current])

    function videoConfig() {
        if (getCurrentLanguage() === 'en') {
            return {
                attributes: { poster: getPosterframe(domain+fragment.posterframe_url) },
                file: {
                    tracks: [{
                        kind: 'subtitles',
                        src: fragment.subtitles_url,
                        srcLang: getCurrentLanguage(),
                        default: true
                    }]
                }
            };
        } else {
            return {
                attributes: { poster: getPosterframe(domain+fragment.posterframe_url) }
            };
        }

    }

    return (
        <>
        {!hidden?
        <div className={(mobileHidden?'is-hidden-mobile':'')+" "+(hidden?'is-hidden':'')+ " video-content"} style={{'width':"100%"}}>
            <ReactPlayer
                playing={!pause}
                width="100%"
                height="100%"
                loop={false}
                muted={mute}
                url={convertVideoResolution(domain+fragment.video_url)}
                playsinline={true}
                config={videoConfig()}
            />
        </div>
        :''}
        </>
    )
}
